import { ComponentCanDeactivate } from "./component-can-deactivate";
import { Injectable } from "@angular/core";
import { CanDeactivate } from "@angular/router";
import { Observable } from "rxjs";

@Injectable()
export class BeforeNavigationGuardService implements CanDeactivate<ComponentCanDeactivate> {

  constructor() {}

  canDeactivate(component: ComponentCanDeactivate): Observable<boolean> | Promise<boolean> | boolean {
    return component.canDeactivate();
  }

}
